import { render, staticRenderFns } from "./AlertLogProcess.vue?vue&type=template&id=b0b52300&"
import script from "./AlertLogProcess.vue?vue&type=script&lang=js&"
export * from "./AlertLogProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports